import { apiRequest, buildURL } from './commons/CommonService.Functions';
import { SnomedItem } from '../models/Entities/Snomed/SnomedModels';

// Base url for snomed specialties search
const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'specialties';

// Search snomed specialties by term (minimum 3 characters)
export const SearchSnomedSpecialties = async (token: string, searchTerm: string): Promise<SnomedItem[]> => {
    const requestUrl: string = buildURL(BaseURL, searchTerm);
    return apiRequest<SnomedItem[]>(requestUrl, token, 'SearchSnomedSpecialties');
};
